import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Box, styled } from '@mui/material'
import { Loading } from '../components/ui'
import { OrderList, OrderListItem, TrackingSellerToolbar, NotFoundData } from '../scenes'
import { RequestTrackingBySellerParams, RequestTrackingLoaderBySellerResponse } from '../types/tracking'
import { trackingService } from '../services'

const loader = async (params: RequestTrackingBySellerParams): Promise<RequestTrackingLoaderBySellerResponse | undefined> => {
    try {
        const request = await trackingService.bySeller(params) as RequestTrackingLoaderBySellerResponse
        return request
    } catch (error) {
        return undefined
    }
}

const PageTrackingSeller = () => {

    const params = useParams()
    const [data, setData] = useState<RequestTrackingLoaderBySellerResponse | undefined>(undefined)

    useEffect(() => {
        let active = true;
        (async () => {
            setData(undefined)
            if (params.id && params.id.length >= 2 && params.id.length <= 8) {
                const request = await loader({ id: params.id as string }) as RequestTrackingLoaderBySellerResponse
                if (!active) {
                    return
                }
                setData(request)
            }
        })()
        return () => {
            active = false
        }
    }, [params])

    return (
        <LayoutStyled>
            {data ? (
                data.listPedido.length > 0 ? (
                    <>
                        <TrackingSellerToolbar
                            seller={data.consultora}
                            quantity={data.listPedido.length}
                        />
                        <OrderList>
                            {data.listPedido.map((order) => {
                                return <OrderListItem data={order} key={order.id} />
                            })}
                        </OrderList>
                    </>
                ) : (
                    <NotFoundData>
                        En este momento no hay ninguna novedad para Consultor/a de belleza { params.id }
                    </NotFoundData>
                )
            ) : (
                <Loading
                    message={
                        <>
                            Un momento por favor,
                            <br/>
                            buscando pedidos de la consultora número <strong>{ params.id }</strong>
                        </>
                    } 
                />
            )}
        </LayoutStyled>
    )
}

const LayoutStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
}))

export default PageTrackingSeller
export { loader }
